<template>
  <div class="mr-3">
    <div class="d-flex align-center">
      <v-switch
        :disabled="loading['ExpectedNMEA']"
        :loading="loading['ExpectedNMEA']"
        v-if="mission.misActifOn"
        hide-details
        class="sm-switch flex-grow-0"
        @change="toggleModule('ExpectedNMEA')"
        :input-value="autoGo"
        :label="$t(`Pilot.MissionDrawer.AutoGo`)"
      />

      <!-- <v-menu class="flex-grow-0" offset-y v-for="toggle in toggleItems" :key="toggle.label">
          <v-btn slot="activator" icon :color="toggleState(toggle.irisModule)?'primary':''" flat :title="$t(`Pilot.MissionDetailMenu.${toggle.label}`)" ><v-icon  >{{toggle.icon}}</v-icon></v-btn>
          <v-list subheader>        
            <v-subheader>{{$t(`Pilot.MissionDetailMenu.${toggle.label}`)}}</v-subheader>                                   
            <v-list-tile  :value="toggleState(toggle.irisModule)"  @click.stop.prevent="toggleModule(toggle.irisModule)">                  
              <div class="d-flex align-end"><v-switch :disabled="loading[toggle.irisModule]" :loading="loading[toggle.irisModule]" hide-details class="sm-switch flex-grow-0" :input-value="toggleState(toggle.irisModule)"></v-switch> Enable</div>
            </v-list-tile> 
          </v-list>     
      </v-menu>     -->
    </div>
  </div>
</template>

<script lang="ts">
import { MISSIONS_DETAIL_TABS } from '@/models/ui/MissionTabs'
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloMission } from '../../models/alo/AloMission'
import { GliderModuleApiId } from '@/models/iris/gliderState/IGliderRuntime'

@Component({
  name: 'MissionAutogo',
  props: {
    mission: {
      type: AloMission,
    },
  },
})
export default class MissionAutogo extends Vue {
  checked: boolean = false
  mission!: AloMission
  // get autoGo() {
  //   return this.$store.myGetters.modifiedExpectedNMEAConfigs && this.$store.myGetters.modifiedExpectedNMEAConfigs[this.mission.gliId!] &&  this.$store.myGetters.modifiedExpectedNMEAConfigs[this.mission.gliId!].mod_settings.ExpectedNMEA.auto_go
  // }

  loading: { [index: string]: boolean } = {}

  get autoGo() {
    return this.toggleState('ExpectedNMEA')
  }

  toggleState(moduleName: String) {
    //on teste si les modules on déjà été chargé sinon on renvoie l'état du glider state
    if (moduleName == 'ExpectedNMEA' && this.originalExpectedNMEASettings)
      return this.originalExpectedNMEASettings.ExpectedNMEA?.auto_go
    else if (moduleName == 'AD2CP' && this.originalAD2CPSettings)
      return this.originalAD2CPSettings.EnabledMOD['module-AD2CP']
    else if (moduleName == 'NextSurfacingDo' && this.originalNextSurfacingDoSettings)
      return this.originalNextSurfacingDoSettings.EnabledMOD['module-NextSurfacingDo']
    else if (moduleName == 'FileTransfer' && this.originalFileTransfertSettings)
      return this.originalFileTransfertSettings.EnabledMOD['module-FileTransfer']
    else if (moduleName == 'SingleWayPoint' && this.originalSingleWayPointSettings)
      return this.originalSingleWayPointSettings.EnabledMOD['module-SingleWayPoint']
    else if (moduleName == 'SendMail' && this.originalSendMailSettings)
      return this.originalSendMailSettings.EnabledMOD['module-SendMail']
    else if (moduleName == 'MissionPlan' && this.originalMissionPlanSettings)
      return this.originalMissionPlanSettings.EnabledMOD['module-MissionPlan']
    // Fallback runtime — clé = mod_api_id (parité ancienne mod_list.find(m=>m.mod_api_id==...))
    else return this.mission.gliderRuntime?.modules?.[moduleName as GliderModuleApiId] ?? false
  }

  get originalExpectedNMEASettings() {
    return this.$store.myGetters.originalExpectedNMEAConfigs[this.mission.gliId!]?.mod_settings
  }

  get originalAD2CPSettings() {
    return this.$store.myGetters.originalAd2cpConfigs[this.mission.misId!]?.mod_settings
  }

  get originalNextSurfacingDoSettings() {
    return this.$store.myGetters.originalNsdConfigs[this.mission.gliId!]?.mod_settings
  }

  get originalFileTransfertSettings() {
    return this.$store.myGetters.originalFileTransfertConfigs[this.mission.gliId!]?.mod_settings
  }

  get originalSingleWayPointSettings() {
    return this.$store.myGetters.originalSingleWayPointConfigs[this.mission.gliId!]?.mod_settings
  }

  get originalSendMailSettings() {
    return this.$store.myGetters.originalSendMailConfigs[this.mission.misId!]?.mod_settings
  }

  get originalMissionPlanSettings() {
    return this.$store.myGetters.originalMissionPlanConfigs[this.mission.misId!]?.mod_settings
  }

  get toggleItems() {
    return MISSIONS_DETAIL_TABS.filter(m => m.iris && this.missionSecurity[m.securityKey].enable)
  }

  get missionSecurity() {
    return this.$store.myGetters.currentDetailMission.mission.security
  }

  toggleModule(moduleName: string) {
    if (!this.loading[moduleName]) {
      let exPromise: Promise<any> | undefined
      if (moduleName == 'ExpectedNMEA')
        exPromise = this.$store.myActions.GLIDER_IRIS_EXPECTED_NMEA_ENABLE_REQUEST({
          itemId: this.mission.gliId!,
          enable: !this.autoGo,
        })
      else if (moduleName == 'AD2CP')
        exPromise = this.$store.myActions.MISSION_IRIS_AD2CP_ENABLE_REQUEST({
          itemId: this.mission.misId!,
          enable: !this.toggleState(moduleName),
        })
      else if (moduleName == 'NextSurfacingDo')
        exPromise = this.$store.myActions.GLIDER_IRIS_NSD_ENABLE_REQUEST({
          itemId: this.mission.gliId!,
          enable: !this.toggleState(moduleName),
        })
      else if (moduleName == 'FileTransfer')
        exPromise = this.$store.myActions.GLIDER_IRIS_FILE_TRANSFERT_ENABLE_REQUEST({
          itemId: this.mission.gliId!,
          enable: !this.toggleState(moduleName),
        })
      else if (moduleName == 'SingleWayPoint')
        exPromise = this.$store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_ENABLE_REQUEST({
          itemId: this.mission.gliId!,
          enable: !this.toggleState(moduleName),
        })
      else if (moduleName == 'SendMail')
        exPromise = this.$store.myActions.MISSION_IRIS_SEND_MAIL_ENABLE_REQUEST({
          itemId: this.mission.misId!,
          enable: !this.toggleState(moduleName),
        })
      else if (moduleName == 'MissionPlan')
        exPromise = this.$store.myActions.MISSION_IRIS_MISSION_PLAN_CONFIG_ENABLE_REQUEST({
          itemId: this.mission.misId!,
          enable: !this.toggleState(moduleName),
        })
      if (exPromise) {
        this.$set(this.loading, moduleName, true)
        exPromise.finally(() => {
          this.loading[moduleName] = false
        })
      }
    }
  }

  toggleAutoGo() {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA({
      itemId: this.mission.gliId!,
      newProperties: {
        mod_settings: {
          ExpectedNMEA: {
            auto_go: !this.autoGo,
          },
        },
      },
    })
    this.$store.myActions.GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST(this.mission.gliId!)
  }
}
</script>
